export function formatPhoneNumber(value) {
  // Remove all non-digit characters and limit to 10 digits
  const digits = (value || '').replace(/\D/g, '').slice(0, 10)

  // Format based on the length of the digits
  if (digits.length === 0) {
    return '' // Return empty for no input
  } else if (digits.length <= 3) {
    return `(${digits}`
  } else if (digits.length <= 6) {
    return `(${digits.slice(0, 3)}) ${digits.slice(3)}`
  } else {
    return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6, 10)}`
  }
}

export const phoneDirective_OLD = {

  bind(el) {
    let isFormatting = false
    el.addEventListener('input', () => {
      if (isFormatting) return

      isFormatting = true
      const formattedValue = formatPhoneNumber(el.value)
      if (el.value !== formattedValue) {
        el.value = formattedValue
        el.dispatchEvent(new Event('input'))
      }
      isFormatting = false
    })
  },
}

export const phoneDirective_OLD_NEW = {
  bind(el, binding, vnode) {
    let isFormatting = false;

    // Reusable function to apply phone number formatting
    const formatValue = () => {
      const formattedValue = formatPhoneNumber(el.value);
      if (el.value !== formattedValue) {
        el.value = formattedValue;
        // Dispatching input event to sync with v-model
        el.dispatchEvent(new Event('input'));
      }
    };

    // Initial formatting when the directive is bound
    formatValue();

    // Listen for input changes and apply formatting
    el.addEventListener('input', () => {
      if (isFormatting) return;

      isFormatting = true;
      formatValue();
      isFormatting = false;
    });

    // Ensure the value is formatted after the component is mounted
    vnode.context.$nextTick(() => {
      formatValue();
    });
  },
};

//todo: consider using vue-the-mask if this doesn't hold up or more options are needed

export const phoneDirective = {
  bind(el, binding, vnode) {
    let isFormatting = false;

    const formatAndSync = (rawValue) => {
      const formatted = formatPhoneNumber(rawValue);
      if (el.value !== formatted) {
        el.value = formatted;
        el.dispatchEvent(new Event('input'));
      }
    };

    // Delay initial formatting to avoid clobbering v-model
    vnode.context.$nextTick(() => {
      if (el.value) {
        formatAndSync(el.value);
      }
    });

    // Handle user typing
    el.addEventListener('input', () => {
      if (isFormatting) return;
      isFormatting = true;

      const newRaw = el.value;
      const formatted = formatPhoneNumber(newRaw);
      if (newRaw !== formatted) {
        el.value = formatted;
        el.dispatchEvent(new Event('input'));
      }

      isFormatting = false;
    });
  },
componentUpdated(el, binding, vnode, oldVnode) {

  const formatted = formatPhoneNumber(String( el.value));

  if (el.value !== formatted) {
    el.value = formatted;
    el.dispatchEvent(new Event('input'));
  }
}
};